import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "~/const";
import { getRoute } from "~/providers/route";
import { userStore } from "~/stores/user";

export default function RootNavigation() {
	const { meLoaded, internalRole } = userStore(userState => ({
		internalRole: userState.user.internalRole,
		meLoaded: userState.userLoad.meLoaded,
	}));
	const navigate = useNavigate();

	useEffect(() => {
		if (meLoaded) {
			if (internalRole === "none") {
				// by default jdeme na dashboard
				navigate(getRoute(ROUTES.MY_PROJECTS.path), { replace: true });
			} else {
				navigate(getRoute(ROUTES.ADMIN_PROJECTS.path), { replace: true });
			}
		}
	}, [meLoaded]);

	return null;
}
